export const SECONDARY_REGISTER_TEXTS = {
    TOAST_MESSAGES: {
        FILL_ALL_FIELDS: "No tan rápido McQueen, por favor llena todos los campos."
    },
    MAIN_TITLE: "Completa tus datos y listooo",
    PROMOTIONAL_TEXT: "Si quiero recibir códigos promocionales y ofertas por correo electrónico y/o WhatsApp",
    BUTTON_LABEL: "Que empiece esto"
};